module.exports = __webpack_public_path__ + "static/img/3.94e8632.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mission/3.png
// module id = ZN8H
// module chunks = 0